import { ArrowUpRight, Instagram, Music2, Youtube } from "lucide-react";
import { SOCIALS } from "@/data/content";
import { FadeUp, SectionHeading } from "./Reveal";

export const SocialSection = () => (
  <section id="social" data-testid="social-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-32">
    <FadeUp>
      <SectionHeading overline="Follow the journey" title="JÀWÀ, in your feed." />
      <p className="mt-6 max-w-xl text-base leading-relaxed text-jawa-espresso/70">
        Daily Lagos life, destination drops and community moments — follow the official JÀWÀ channels.
      </p>
    </FadeUp>
    <div className="mt-14 grid gap-6 md:grid-cols-3">
      <FadeUp>
        <a
          href={SOCIALS.youtube}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="social-youtube"
          className="group relative block h-full overflow-hidden border border-jawa-stone bg-white p-10 lg:p-12"
        >
          <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-jawa-coral/10 blur-2xl transition-all duration-500 group-hover:bg-jawa-coral/20" />
          <Youtube className="h-10 w-10 text-jawa-coral" />
          <p className="mt-8 font-serif text-3xl font-medium tracking-tight text-jawa-espresso">JÀWÀ Africa</p>
          <p className="mt-2 text-sm text-jawa-espresso/60">Watch the journey — films, guides and community stories.</p>
          <span className="mt-8 inline-flex items-center gap-2 bg-jawa-espresso px-6 py-3 text-xs font-bold uppercase tracking-[0.25em] text-jawa-ivory transition-colors group-hover:bg-jawa-coral">
            Watch on YouTube <ArrowUpRight className="h-4 w-4" />
          </span>
        </a>
      </FadeUp>
      <FadeUp delay={0.08}>
        <a
          href={SOCIALS.tiktok}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="social-tiktok"
          className="group relative block h-full overflow-hidden bg-jawa-nearblack p-10 lg:p-12"
        >
          <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-jawa-turquoise/20 blur-2xl transition-all duration-500 group-hover:bg-jawa-turquoise/30" />
          <Music2 className="h-10 w-10 text-jawa-turquoise" />
          <p className="mt-8 font-serif text-3xl font-medium tracking-tight text-jawa-ivory">@jawaafrica</p>
          <p className="mt-2 text-sm text-jawa-ivory/60">Short films, city guides and real Lagos days.</p>
          <span className="mt-8 inline-flex items-center gap-2 bg-jawa-turquoise px-6 py-3 text-xs font-bold uppercase tracking-[0.25em] text-jawa-nearblack transition-colors group-hover:bg-jawa-ivory">
            Follow JÀWÀ on TikTok <ArrowUpRight className="h-4 w-4" />
          </span>
        </a>
      </FadeUp>
      <FadeUp delay={0.16}>
        <a
          href={SOCIALS.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="social-instagram"
          className="group relative block h-full overflow-hidden bg-jawa-espresso p-10 lg:p-12"
        >
          <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-jawa-coral/25 blur-2xl transition-all duration-500 group-hover:bg-jawa-coral/40" />
          <Instagram className="h-10 w-10 text-jawa-coral" />
          <p className="mt-8 font-serif text-3xl font-medium tracking-tight text-jawa-ivory">@jawaafrica</p>
          <p className="mt-2 text-sm text-jawa-ivory/60">Editorial photography, events and community.</p>
          <span className="mt-8 inline-flex items-center gap-2 bg-jawa-coral px-6 py-3 text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors group-hover:bg-jawa-ivory group-hover:text-jawa-espresso">
            Follow JÀWÀ on Instagram <ArrowUpRight className="h-4 w-4" />
          </span>
        </a>
      </FadeUp>
    </div>
  </section>
);
